import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import knowledgeBase from "@/middlewares/knowledgeBase"

const knowledgeBaseRoutes: RouteRecordRaw[] = [
  {
    path: "/knowledge-base",
    redirect: { name: "knowledge-base-brand-profile" },
  },
  {
    path: "/knowledge-base/brand-profile",
    name: "knowledge-base-brand-profile",
    component: () => import("@/views/knowledge-base/KnowledgeBaseBrandProfile.vue"),
    meta: {
      middleware: [auth, knowledgeBase],
      title: "knowledge_base.brand_profile.page_title",
    },
  },
  {
    path: "/knowledge-base/recurring-situations",
    name: "knowledge-base-recurring-situations",
    component: () => import("@/views/knowledge-base/KnowledgeBaseRecurringSituations.vue"),
    meta: {
      middleware: [auth, knowledgeBase],
      title: "knowledge_base.recurring_situations.page_title",
    },
  },
  {
    path: "/knowledge-base/personas",
    name: "knowledge-base-personas",
    component: () => import("@/views/knowledge-base/KnowledgeBasePersonas.vue"),
    meta: {
      middleware: [auth, knowledgeBase],
      title: "knowledge_base.personas.page_title",
    },
  },
  {
    path: "/knowledge-base/activity-catalogs",
    name: "knowledge-base-activity-catalogs",
    component: () => import("@/views/knowledge-base/KnowledgeBaseActivityCatalogs.vue"),
    meta: {
      middleware: [auth, knowledgeBase],
      title: "knowledge_base.activity_catalogs.page_title",
    },
  },
  {
    path: "/knowledge-base/signatures",
    name: "knowledge-base-signatures",
    component: () => import("@/views/knowledge-base/KnowledgeBaseSignatures.vue"),
    meta: {
      middleware: [auth, knowledgeBase],
      title: "knowledge_base.signatures.page_title",
    },
  },
]

export default knowledgeBaseRoutes
